import { useContext } from 'react';
import { MailApi } from '@europrocurement/l2d-domain/openApi/ApiMail';
import L2DApiContext from '../L2DApiContext';

export const useMailService = () => {
    const context = useContext(L2DApiContext);
    if (!context) {
        throw new Error('useL2DApi must be used within a L2DApiProvider');
    }

    if (!context.mail) {
        throw new Error('Mail service is not registred in L2DApiProvider');
    }
    const { apis } = context.mail;

    return {
        mailApi: apis.mailApi as MailApi,
    };
};
